<template>
  <div :class="timeoutClass">
    {{ countdown }}<span v-if="timeout">（超时）</span>
  </div>
</template>

<script>
export default {
  props: {
    createdTime: String
  },
  data() {
    return {
      countdown: "",
      timeout: false,
      timeoutClass: "",
      interval: null
    };
  },
  created() {
    const time = this.time(this.createdTime);
    this.countdown = this.value(time);
    this.handleCountdown();
  },
  methods: {
    time(created_time) {
      const curtime = new Date().getTime();
      const pastTime = new Date(created_time).getTime();
      const isDecrease = pastTime + 86400000 - curtime > 0 ? true : false;
      const isIncrease =
        pastTime + 86400000 - curtime <= 0 &&
        pastTime + 86400000 * 2 - curtime >= 0
          ? true
          : false;
      const isUnchanged = pastTime + 86400000 * 2 - curtime < 0 ? true : false;
      const increaseTime = (curtime - (pastTime + 86400000)) / 1000;
      const decreaseTime = (pastTime + 86400000 - curtime) / 1000;
      return {
        isIncrease,
        isDecrease,
        isUnchanged,
        increaseTime,
        decreaseTime
      };
    },
    value(time) {
      if (time.isDecrease) {
        return this.valueFormat(time.decreaseTime);
      } else if (time.isIncrease) {
        this.timeout = true;
        this.timeoutClass = "danger-color";
        return this.valueFormat(time.increaseTime);
      } else {
        this.timeout = true;
        this.timeoutClass = "danger-color";
        return this.createdTime;
      }
    },
    valueFormat(time) {
      let hours = this.timeFormat(parseInt((time % (60 * 60 * 24)) / 3600));
      let minutes = this.timeFormat(
        parseInt(((time % (60 * 60 * 24)) % 3600) / 60)
      );
      let seconds = this.timeFormat(
        parseInt(((time % (60 * 60 * 24)) % 3600) % 60)
      );
      return hours + ":" + minutes + ":" + seconds;
    },
    timeFormat(time) {
      return time < 10 ? "0" + time : time;
    },
    handleCountdown() {
      this.interval = setInterval(() => {
        const time = this.time(this.createdTime);
        this.countdown = this.value(time);
        if (time.isUnchanged) {
          clearInterval(this.interval);
        }
      }, 1000);
    }
  }
};
</script>
